<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1 style="font-family:Calisto MT; font-size:18pt; letter-spacing:1px; padding-top:75px; padding-bottom:0px;">Dedication</h1>
<p>This book is dedicated to Anne, my wonderful, faith-filled wife, whose courage in the face of adversity is an example to us all; to my family who are such a blessing; and to the pastors and friends at Arise Church, with whom it is my absolute privilege and blessing to be able to do life, for their immeasurable prayer and practical love and support.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?b10f7e62